import React from "react";
import { useSearchParams } from "react-router-dom";
import { ShieldCheck, Radio, Landmark } from "lucide-react";
import { Reveal } from "../components/motion";
import { PageHero, CtaBand } from "../components/shared";
import { QuoteForm } from "../components/QuotePanel";
import { img, needFromParam } from "../data/site";

const POINTS = [
  [ShieldCheck, "Sopralluogo gratuito", "Un responsabile visita la struttura e ascolta le tue esigenze, senza impegno."],
  [Radio, "Due centrali operative H24", "San Cesareo e Bascapè, certificate UNI CEI EN 50518, in backup reciproco."],
  [Landmark, "Dal 1992", "Istituto di vigilanza autorizzato con licenza prefettizia n. 283167."],
];

export default function Preventivo() {
  const [params] = useSearchParams();
  const pre = needFromParam(params.get("servizio"));
  return (
    <>
      <PageHero
        kick="Preventivo"
        lines={["Preventivo gratuito", "in un minuto."]}
        sub="Sopralluogo gratuito, nessun impegno. Ti ricontattiamo noi."
        ph={img("control-room.jpg")}
      />

      <section className="sec" style={{ paddingTop: 60 }} data-testid="preventivo-page">
        <div className="wrap" style={{ display: "flex", flexWrap: "wrap", gap: "44px 80px" }}>
          <Reveal style={{ flex: "1 1 560px", minWidth: 0 }}>
            <QuoteForm preServizio={pre || ""} provenance="/preventivo" idPrefix="pv" tid={(s) => `pv-${s}`} />
          </Reveal>
          <Reveal delay={0.08} style={{ flex: "1 1 340px", minWidth: 0, display: "grid", gap: 16, alignContent: "start" }}>
            <h2 className="sr-only">Perché sceglierci</h2>
            {POINTS.map(([Icon, t, d], i) => (
              <div className="mini" key={t} data-testid={`pv-point-${i}`}>
                <div className="mic">
                  <Icon size={20} aria-hidden="true" />
                </div>
                <h3>{t}</h3>
                <p>{d}</p>
              </div>
            ))}
          </Reveal>
        </div>
      </section>

      <CtaBand testid="preventivo-cta" />
    </>
  );
}
